import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ITipoPlazo } from '../../shared/interfaces/database/configuracion';


@Injectable({
  providedIn: 'root'
})
export class TipoPlazoService {
  private readonly baseUrl = `${environment.apiUrl}/api/tipo-plazo`;

  constructor(private http: HttpClient) { }

  getTipoPlazos(): Observable<ITipoPlazo[]> {
    return this.http.get<ITipoPlazo[]>(`${this.baseUrl}`);
  }
}
